var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighContrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "stroke-color-main",
    cx: 100,
    cy: 100,
    r: 59.364
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-color-main",
    d: "M100,40.636V159.364a59.364,59.364,0,1,0,0-118.728Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighContrast);
export default __webpack_public_path__ + "static/media/high-contrast.ef7e0c1c3055ca73ff6e78e8d61dbd6f.svg";
export { ForwardRef as ReactComponent };